import { createSelector } from '@ngrx/store';
import { creditCardsState } from '../root';

export const showAddCardForm = createSelector(creditCardsState, (creditCards) => creditCards.showAddCardForm);
